import nookies from 'nookies'

export const getPreferredLangId = ctx => {
  let { selectedLanguage } = nookies.get(ctx)
  selectedLanguage = (selectedLanguage && JSON.parse(selectedLanguage)) || {}
  return selectedLanguage.id
}

const getSelectedLanguage = async (ctx, prefferedLanguageId = null) => {
  const langId = prefferedLanguageId || getPreferredLangId(ctx)
  const dictionaryList = {}
  switch (langId) {
    case 'hi':
      dictionaryList[langId] = await (await import('../languages/hi')).default
      break
    case 'kn':
    case 'kn-IN':
      dictionaryList[langId] = await (await import('../languages/kn')).default
      break
    case 'ar':
      dictionaryList[langId] = await (await import('../languages/ar')).default
      break
    default:
      dictionaryList.en = await (await import('../languages/en')).default
      break
  }
  return dictionaryList
}

export default getSelectedLanguage
